import React from 'react';
import HeroSection from '../components/HeroSection';
import ProblemSection from '../components/ProblemSection';
import FeaturesSection from '../components/FeaturesSection';
import HowItWorksSection from '../components/HowItWorksSection';
import PricingSection from '../components/PricingSection';
import Footer from '../components/Footer';
import StickyNoteCTA from '../components/StickyNoteCTA';
import {
  heroData,
  problemStatements,
  keyFeatures,
  howItWorksSteps,
  pricingData,
  socialProof,
} from '../data/mockData';

const LandingPage = () => {
  return (
    <div style={{ background: 'var(--bg-page)' }}>
      <StickyNoteCTA price={heroData.ctaPrice} ctaText={heroData.ctaText} />
      <HeroSection data={heroData} />
      <ProblemSection problems={problemStatements} />
      <FeaturesSection features={keyFeatures} />
      <HowItWorksSection steps={howItWorksSteps} />
      <PricingSection pricing={pricingData} socialProof={socialProof} />
      <Footer />
    </div>
  );
};

export default LandingPage;
